const galleryId = 78;

const items = [];

let id = galleryId * 1000;

function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}
let group = [];

group = ["sh_1361950133.jpg","sh_1808525872.jpg","sh_1479855842.jpg","sh_124087642.jpg","sh_578733967.jpg","sh_1662934903.jpg"];
group.forEach((i) => addItemToGroup(i, '1. Discolored teeth'));

group = ["sh_1751363984.jpg","sh_1780338788.jpg","sh_1829640860.jpg"];
group.forEach((i) => addItemToGroup(i, '2. Teeth whitening'));

group = ["sh_167843159.jpg","sh_1808121076.jpg","sh_1829250998.jpg","sh_712781413.jpg","sh_789655126.jpg","sh_1751363978.jpg","sh_504535285.jpg","sh_1016394343.jpg","sh_1196509231.jpg","sh_1554082265.jpg","sh_1512852149.jpg"];
group.forEach((i) => addItemToGroup(i, 'Before-after'));

export default items;
